export default __webpack_public_path__ + "static/media/AfterPhoto7.223f4bd8.jpg";